import * as React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import {
    Card,
    Typography,
    List,
    Collapse,
    IconButton,
    //Alert,
} from "@material-tailwind/react";
import {
    NavArrowDown,
    Menu,
    Xmark,
} from "iconoir-react";

import AppImages from "../assets/AppImages";
import { DashboardPage, dashboard_pages } from '../utils/dashboard_pages';
import {
    logoutRequest,
} from '../redux/auth/actions';
import { useLocation } from "react-router-dom";
import { RootState } from "../redux";

interface DashboardSidebarProps {
}

const DashboardSidebar: React.FC<DashboardSidebarProps> = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setIsOpen] = React.useState<{ [key: string]: boolean }>({});
    const [showSidebar, setShowSidebar] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(false);
    const { auth } = useSelector((state: RootState) => state.auth);

    React.useEffect(() => {
        const newTab = location.pathname.split('/')[2];
        setIsOpen({
            ...isOpen,
            [newTab]: true,
        });
    }, [location]);

    React.useEffect(() => {
        function handleResize() {
            if (window.innerWidth >= 960) {
                setShowSidebar(true);
                setIsMobile(false);
            } else {
                setShowSidebar(false);
                setIsMobile(true);
            }
        }

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <React.Fragment>
            <IconButton
                color="secondary"
                className={`h-[40px] md:hidden bg-background !fixed z-30 top-5 ${
                    showSidebar ? "right-5" : "left-5"
                }`}
                onClick={() => setShowSidebar(!showSidebar)}
            >
                {showSidebar ? <Xmark className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </IconButton>

            {showSidebar && (
                <React.Fragment>
                    <div className="fixed md:hidden inset-0 flex min-h-full top-0 left-0 min-w-full z-20 items-center justify-center bg-gray-600 bg-opacity-50"></div>
                    <Card className="fixed scrollbar-hide h-full max-h-[calc(100dvh-2.5rem)] min-w-[calc(100vw-90px)] max-w-[calc(100vw-90px)] md:relative md:min-w-[250px] md:max-w-[250px] z-30 flex flex-col m-5 overflow-y-auto">
                        <Card.Header className="m-0 px-6 pt-4 h-max w-full">
                            <Link to="/">
                                <div className="items-center pb-6 my-4 border-b">
                                    <img
                                        className="w-[50%]"
                                        src={AppImages.logo}
                                        alt="material tailwind logo"
                                    />
                                </div>
                            </Link>
                        </Card.Header>

                        <Card.Body className="px-6 pb-6 pt-0">
                            {dashboard_pages.map((section, sec_idx) => (
                                <List
                                    key={sec_idx}
                                    className={`min-w-50 ${
                                        sec_idx == 0 ? "border-b border-surface mb-4 pb-4" : ""
                                    }`}
                                >
                                    {section
                                        .filter((page) => !page.hidden)
                                        .filter((page) => {
                                            return (
                                                !page?.showToRoles ||
                                                page.showToRoles?.includes(
                                                    auth?.user?.role?.title || ""
                                                )
                                            );
                                        })
                                        .map((page: DashboardPage, page_idx: number) => (
                                            <div key={page_idx}>
                                                <NavLink to={page.link}>
                                                    {({ isActive }) => (
                                                        <List.Item
                                                            onClick={(
                                                                event: React.MouseEvent<HTMLLIElement>
                                                            ) => {
                                                                if (page.child) {
                                                                    setIsOpen({
                                                                        ...isOpen,
                                                                        [page.link]:
                                                                            !isOpen[page.link],
                                                                    });
                                                                    event.preventDefault();
                                                                    event.stopPropagation();
                                                                } else if (isMobile) {
                                                                    setShowSidebar(false);
                                                                }

                                                                if (page.link == "signout") {
                                                                    dispatch(logoutRequest());
                                                                    event.preventDefault();
                                                                    event.stopPropagation();
                                                                }
                                                            }}
                                                            className={`px-5 ${
                                                                isActive
                                                                    ? "py-4 bg-gray-100"
                                                                    : "py-3"
                                                            }`}
                                                        >
                                                            <List.ItemStart>
                                                                <page.icon
                                                                    className={`w-5 h-5 ${
                                                                        isActive
                                                                            ? "text-primary"
                                                                            : "text-secondary"
                                                                    }`}
                                                                />
                                                            </List.ItemStart>
                                                            <Typography
                                                                className={`text-sm ${
                                                                    isActive
                                                                        ? "font-medium text-[#1F2937]"
                                                                        : "text-[#64748B]"
                                                                }`}
                                                            >
                                                                {page.title}
                                                            </Typography>

                                                            {page.child && (
                                                                <List.ItemEnd>
                                                                    <NavArrowDown
                                                                        className={`h-4 w-4 stroke-2 transition-transform ${
                                                                            isOpen[page.link]
                                                                                ? "rotate-180"
                                                                                : ""
                                                                        }`}
                                                                    />
                                                                </List.ItemEnd>
                                                            )}
                                                        </List.Item>
                                                    )}
                                                </NavLink>

                                                {page.child && (
                                                    <Collapse open={isOpen[page.link]}>
                                                        <List className="min-w-40">
                                                            {page.child
                                                                .filter((child) => !child.hidden)
                                                                .filter((child) => {
                                                                    return (
                                                                        !child?.showToRoles ||
                                                                        child.showToRoles?.includes(
                                                                            auth?.user?.role
                                                                                ?.title || ""
                                                                        )
                                                                    );
                                                                })
                                                                .map(
                                                                    (
                                                                        child: DashboardPage,
                                                                        child_idx: number
                                                                    ) => (
                                                                        <NavLink
                                                                            key={child_idx}
                                                                            to={child.link}
                                                                        >
                                                                            {({ isActive }) => (
                                                                                <List.Item
                                                                                    className={`pl-[41px] ${
                                                                                        isActive
                                                                                            ? "py-3 bg-gray-100 font-medium text-[#1F2937]"
                                                                                            : "py-2 text-[#64748B]"
                                                                                    }`}
                                                                                    onClick={() => {
                                                                                        if (
                                                                                            isMobile
                                                                                        ) {
                                                                                            setShowSidebar(
                                                                                                false
                                                                                            );
                                                                                        }
                                                                                        navigate(
                                                                                            child.link
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <Typography className="text-sm">
                                                                                        {
                                                                                            child.title
                                                                                        }
                                                                                    </Typography>
                                                                                </List.Item>
                                                                            )}
                                                                        </NavLink>
                                                                    )
                                                                )}
                                                        </List>
                                                    </Collapse>
                                                )}
                                            </div>
                                        ))}
                                </List>
                            ))}
                        </Card.Body>
                        <Card.Footer className="p-6 mt-auto">
                            {/*
                  <Alert variant="ghost" color="success">
                      <Alert.Content>
                          <Typography
                              type="small"
                              color="success"
                              className="font-semibold block mb-2"
                          >
                              New Version Available
                          </Typography>
                          <Typography type="small" color="success" className="block mb-4">
                              Update your app and enjoy the new features and improvements.
                          </Typography>
                          <div className="flex items-center gap-4">
                              <Typography
                                  as={Alert.DismissTrigger}
                                  type="small"
                                  color="error"
                                  className="font-semibold block"
                              >
                                  Dismiss
                              </Typography>
                              <Typography
                                  as="a"
                                  href="#"
                                  type="small"
                                  color="success"
                                  className="font-semibold block"
                              >
                                  Upgrade Now
                              </Typography>
                          </div>
                      </Alert.Content>
                  </Alert>
            */}
                            <Typography
                                type="small"
                                className="text-center block mt-6 text-foreground"
                            >
                                TurboCar {new Date().getFullYear()}
                            </Typography>
                        </Card.Footer>
                    </Card>
                </React.Fragment>
            )}
        </React.Fragment>
    );};

export default DashboardSidebar;
